import { Component, Inject, ViewChild } from '@angular/core';
import { VentanaFlotante } from '../../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComentarioComponent } from '../detalle-peticion/comentario/comentario.component';
import { MatTableDataSource } from '@angular/material/table';
import { UsuarioService } from '../../services/user.service';
import { DetallePetCorredor } from './DetallePetCorredor';
import {AlertArgumentarioComponent} from "../../../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {GestionesVariasService} from "../../services/bd/GestionesVarias/gestiones-varias.service";
import {EmailService} from "../../services/email.service";
import {GestionPeticionService} from "../../services/bd/GestionPeticion/gestion-peticion.service";
import {AgentsService} from "../../services/bd/Agents/agents.service";
import {ListadoColaboradoresComponent} from "../../axa/listado-colaboradores.component";
import {ListadoComentariosComponent} from "../../listado-comentarios/listado-comentarios.component";
@Component({
  selector: 'ral-det-peticion-corredores',
  templateUrl: './det-peticion-corredores.component.html',
  styleUrls: ['./det-peticion-corredores.component.scss']
})
export class DetPeticionCorredoresComponent extends VentanaFlotante
{
  comentarioColumns :string[] = ["Lin.","Fecha/Hora","Comentário","Usuario"];
  comentarios:ComentarioContact[] = [];
  comentarioSource: MatTableDataSource<ComentarioContact> = new MatTableDataSource(this.comentarios);
  usuario:string = "";
  infoPeticion : DetallePetCorredor = new DetallePetCorredor();
  mostrarCarga:boolean = true;
  estadoAnterior: string = "";
  showCliente: boolean = false;
  showEmail: boolean = false;
  showEmailbtn: boolean = false;
  showAnulacion: boolean = false;
  showAlert: boolean = false;
  tipoEmail: string = "";
  tipoAnula: string = "";
  hover: boolean = false;
  arrayAnulaRellamada = [
    "Decisión del Cliente",
    "Otro taller NO Ralarsa",
    "Otros Daños",
    "Petición Duplicada"
  ];  
  arrayAnulaAnulado = [
  "Cliente ilocalizable",
  "Otro taller no Ralarsa",
  "No rotura",
  "Servicio no procede"
  ];
  arrayAnula: string[] = [];
  arrayEstado = ["Pendiente", "Gestionado", "Completado", "Anulado", "Rellamada"];
  arrayEmail = ["EMAIL NO CONTESTA", "EMAIL TELÉFONO INCORRECTO", "EMAIL ANULACIÓN DE SERVICIOS"];
  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private dialogComentario : MatDialog, // Additional parameter to override in the constructor
    private userService:UsuarioService,
    private peticionService:GestionesVariasService,
    private comentario: GestionPeticionService,
    private emailService: EmailService,
    private agentsService: AgentsService,
    private dialog: MatDialog,
  )
  {super(dialogRef, data);}

  ngOnInit() {
      this.peticionService.getForId(this.data.token, this.data.peticion.toString()).then(res => {
        switch (this.data.padre.controlGestion){
          case "CORREDORES":
            this.infoPeticion.tipo = "Gestión Corredores";
            break;
          case "COLABORADORES RLS":
            this.infoPeticion.tipo = "Gestión Colaboradores RLS";
            break;
        }
        this.infoPeticion.convertirDetalle(res, this);
        this.peticionService.getSubAgente(this.data.token, this.infoPeticion.agente, this.infoPeticion.subdelega).then(res => {
          if (res.length > 0){
            this.infoPeticion.taller = res[0].delegacion.toString().trim();
            this.infoPeticion.nsubdelega = res[0].nom.toString().trim();
          }
        }).finally(() =>{
          this.peticionService.getAgente(this.data.token, this.infoPeticion.agente).then(res => {
            if(res.length > 0){
              if(this.infoPeticion.taller.toString().trim() == "0"){
                this.infoPeticion.taller = res[0].delegacio.toString().trim();
              }
              this.infoPeticion.nomAgente = res[0].nom.toString().trim();
              this.infoPeticion.email = res[0].email.toString().trim();
              this.infoPeticion.telefono = res[0].telef1.toString().trim();
            }
          });
        });
      }).finally(() => {
        this.usuario = this.userService.getNombreCuenta();
          this.peticionService.getLineasComentario(this.data.token, this.data.peticion)
            .then(res => {
              this.comentarios = res;
              this.comentarioSource.data = this.comentarios;
              this.estadoAnterior = this.infoPeticion.estado;
              
              if(this.infoPeticion.estado == "3"){
                this.arrayAnula = this.arrayAnulaAnulado;
              }
              if(this.infoPeticion.estado == "4"){
                this.arrayAnula = this.arrayAnulaRellamada;
              }
            })
            .catch(err => {
              this.data.padre.formInic.mostrarArgumentario("Error", ["Ha habido un error al insertar el comentario"], false, true, true);
              this.mostrarCarga = false;
            })
            .finally(() => {
              this.mostrarCarga = false;
            })
      });

  }

  abrirGrande(){
    const listado = this.dialog.open(ListadoComentariosComponent, {
      data: { datos:this.comentarios, columns:['linea', 'created', 'obser', 'usuario'] },
    });
  }
  agregarComentario()
  {
    const dialogRef = this.dialogComentario.open(ComentarioComponent,
      {data:
        {
          token:this.data.token,
          idPeticion:this.data.peticion,
          tipo: this.data.padre.controlGestion,
          numNuevaLinea : this.comentarios.length+1, //EL CONTROLLER YA SE ENCARGA DE CALCULAR EL NUMERO DE LINEA

        }
      }
    );

    dialogRef.afterClosed()
    .subscribe(result =>
    {
      //SI el result es valido
      if(result != undefined && result != null && result != "")
      {
        const hoyAhora = this.getHoy();
        //asignamos el taller seleccionado del buscador al form principal
        this.agregarOrdenado(result);
      }
    });
  }

  //vuelca los datos del detalle a la ventana principal
  generarHoja()
  {
    this.infoPeticion.convertirHoja(this.data.padre.formInic);
    this.dialogRef.close(true);
  }
  //retorna la fecha y hora actuales en formato string
  private getHoy():string
  {
    const currentDate = new Date();
    return currentDate.toLocaleString('es-ES',
    {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  //agrega el comentario nuevo y ordena el listado
  //despues, actualiza el source
  private agregarOrdenado(comentario:ComentarioContact)
  {
    this.comentarios.push(comentario);
    // Ordenamos el array por linea (Descendiente)
    this.comentarios = this.ordenarComentariosPorLinea(this.comentarios);
    this.comentarioSource.data=this.comentarios;
  }

  private ordenarComentariosPorLinea(comentarios: ComentarioContact[]): ComentarioContact[]
  {
    return comentarios.sort((a, b) => b.linea - a.linea);
  }

  cambiarEstado(nuevoEstado: string){
    const dialogRef = this.data.padre.formInic.dialog.open(AlertArgumentarioComponent,
      {
        data: {
          titulo: "Atención",
          lineas: ["Realmente desea cambiar el estado de la petición?"],
          mostrarBtnAceptar: true
        }
        ,disableClose:true
      });
    dialogRef.afterClosed().subscribe((result: boolean)  => {
      if (result){
        if((nuevoEstado == "2") && !this.data.padre.permisoGestionUsuario.includes(this.userService.getNombreCuenta())){
          this.data.padre.formInic.mostrarArgumentario("Alerta!", ["No tiene permisos para poner como completado la petición", "Contactar con Roser."], false, true, true);
          this.infoPeticion.estado= this.estadoAnterior;
        }else{
          this.estadoAnterior = nuevoEstado;
          let paramArr = [];
          let param = {
            "id": this.data.peticion,
            "estado_servicio": nuevoEstado,
            "usuario": this.userService.getNombreCuenta()
          }
          paramArr.push(param);
          this.peticionService.UpdateEstadoWeb(this.data.token, paramArr).then(
            (res: any) => {
              if(res){
                //Actualizo el motivo de anulacion x depende que estado.
                this.actualizarMotivosYEmailPorEstado(nuevoEstado);
                this.data.padre.formInic.mostrarArgumentario("OK",["Se ha cambiado el estado de la petición!"],true);
                var comentarioNuevo:ComentarioContact = {linea:this.comentarioSource.data.length+1,created:this.getHoy(),obser:"Cambio estado de incidencia a "+ this.arrayEstado[Number(nuevoEstado)],usuario:this.usuario};
                this.comentario.InsertarLineaComentario(this.data.token,this.data.peticion,comentarioNuevo,this.data.padre.controlGestion).then(res => {
                  if(res){
                    this.agregarOrdenado(comentarioNuevo);
                  }
                });
                if(nuevoEstado == "4" || nuevoEstado == "3" ){
                  this.showEmailbtn = true;
                  this.showEmail = true;
                }else{
                  this.showEmail = false;
                  this.showEmailbtn = false;
                }
              }
            },
            (err:any) => {
              this.data.padre.formInic.mostrarArgumentario("Error", [err.message], true, true, true);
            }
          )
        }
      }else{
        this.infoPeticion.estado= this.estadoAnterior;
      }
    });
  }
  cambiarEmail(nuevoTipo: string){
    if (nuevoTipo == "3"){
      this.showAnulacion = true;
      this.showEmailbtn = false;
      if(this.infoPeticion.estado == "3"){
        this.arrayAnula = this.arrayAnulaAnulado;
      }
      if(this.infoPeticion.estado == "4"){
        this.arrayAnula = this.arrayAnulaRellamada;
      }
    }else{
      this.showAnulacion = false;
      this.showEmailbtn = true;
    }
  }

  //Cuando actualizamos el estado en este caso actualizamos tambien los motivos. 
  private actualizarMotivosYEmailPorEstado(estado: string){
  
    if(estado == "3"){ // ANULADO
      this.arrayAnula = this.arrayAnulaAnulado;
      this.showAnulacion = true;
      this.showEmail = true;
      this.showEmailbtn = false;
      this.showAnulacion = true;

    }else if(estado == "4"){ // RELLAMADA
      this.arrayAnula = this.arrayAnulaRellamada;
      this.showAnulacion = false;
      this.showEmail = true;
      this.showEmailbtn = true;

    }else{
      this.arrayAnula = [];
      this.showAnulacion = false;
      this.showEmail = false;
      this.showEmailbtn = false;
    }

    // reset selección para evitar bugs
    this.tipoAnula = "";
  }

  cambiarMotivo(nuevoMotivo: string){
    this.showEmailbtn = nuevoMotivo !== "";
  }
  async enviarEmail() {
    let emailTo = await this.getEmails();
    if (this.tipoEmail <= "0") {
      this.data.padre.formInic.mostrarArgumentario("Atención!", ["Debes de seleccionar tipo de e-mail para enviar-lo."], true, true, true);
    } else {
      var asuntoBase = `Petición RLS ${this.infoPeticion.agente} ${this.infoPeticion.nomAgente}:${this.infoPeticion.id} Matrícula: ${this.infoPeticion.matricula} .`;
      var cuerpoBase = `Estimado Sr/Sra.,
        Datos facilitados del asegurado:
        * Fecha de petición de servicio: ${this.infoPeticion.fechaPet}
        * Nombre del asegurado: ${this.infoPeticion.nomCliente}
        * Matricula: ${this.infoPeticion.matricula}
        * Teléfono del asegurado: ${this.infoPeticion.telServ}
        `;

      switch (this.tipoEmail.charAt(0)) {
        case '1': // Email no contesta
          asuntoBase = `${asuntoBase}Cliente asegurado no contesta.`;
          cuerpoBase += `Después de realizar un mínimo de 3 llamadas le informamos que no hemos conseguido contactar con su cliente asegurado para concertar una cita. 
          Hemos enviado un mensaje vía whatsapp a su cliente solicitándole más datos y dándole la opción de solicitar cita directamente en nuestra página web. 
          Si existe alguna particularidad para poder contactar con su cliente puede ponerse en contacto con nosotros en la siguiente dirección gestionrls@ralarsa.com.`;
          break;

        case '2': // Email telefono incorrecto
          asuntoBase = `${asuntoBase}Teléfono incorrecto.`;
          cuerpoBase += `Le informamos que el teléfono de contacto que nos ha facilitado para contactar con su cliente asegurado no es el correcto por lo que no podemos concertar una cita.
          Nuestro equipo comercial se pondrá en contacto con usted para validar los datos del cliente.`;
          break;

        case '3': // Anulación del servicio
          asuntoBase = `${asuntoBase}Anulación del servicio. ${this.tipoAnula}`;
          cuerpoBase += `Después de realizar un mínimo de 3 llamadas le informamos que no hemos conseguido contactar con su cliente asegurado para concertar una cita. 
          Hemos enviado un mensaje vía whatsapp a su cliente solicitándole más datos y dándole la opción de solicitar cita directamente en nuestra página web. 
          Si existe alguna particularidad para poder contactar con su cliente puede ponerse en contacto con nosotros en la siguiente dirección gestionrls@ralarsa.com`;
          break;
      }

      cuerpoBase += `Muchas gracias por su atención.
        Dpto. de Atención al Cliente RLS - Auto Cristal Ralarsa
        En caso de responder a este correo hágalo a gestionrls@ralarsa.com`;
      
      var arrParams = {
        "sender": "gestionrls@ralarsa.com",
        "to": emailTo,
        "bcc": ["balonso@ralarsa.com","marketing@ralarsa.com"],
        "subject": asuntoBase,
        "body": cuerpoBase
      }

      this.emailService.enviarEmail(this.data.token, arrParams).then(res => {
        if(res == "OK"){
          this.data.padre.formInic.mostrarArgumentario("OK", ["Email enviado correctamente."], false, true, false);
          var comentarioNuevo: ComentarioContact;
          if (this.tipoEmail == "3"){
            comentarioNuevo = {linea:this.comentarioSource.data.length+1,created:this.getHoy(),obser:"ENVIADO "+ this.arrayEmail[Number(this.tipoEmail)-1] + " " + this.arrayAnula[Number(this.tipoAnula)-1].toString().toUpperCase(),usuario:this.usuario};
          }else{
            comentarioNuevo = {linea:this.comentarioSource.data.length+1,created:this.getHoy(),obser:"ENVIADO "+ this.arrayEmail[Number(this.tipoEmail)-1],usuario:this.usuario};
          }
          this.comentario.InsertarLineaComentario(this.data.token,this.data.peticion,comentarioNuevo,this.data.padre.controlGestion).then(res => {
            if(res){
              this.agregarOrdenado(comentarioNuevo);
            }
          });
        }else{
          this.data.padre.formInic.mostrarArgumentario("Error", ["Ha habido un error al enviar el e-mail"], false, true, true);
        }
      });
    }
  }

  async getEmails(): Promise<string[]>
  {
    let emailTall: string = "";
    let emailResp: string = "";
    const result: string[] = [];

    try {
      // Obtener email del agente
      let res = await this.agentsService.getEmailSubAgents(this.data.token, this.infoPeticion.agente, this.infoPeticion.subdelega);

      if (res.length > 0 && res[0].email.toString().trim() != "") {
        emailTall = res[0].email.toString().trim();
      } else {
        res = await this.agentsService.getEmailAgents(this.data.token, this.infoPeticion.agente);
        if (res.length > 0 && res[0].email.toString().trim() != "") {
          emailTall = res[0].email.toString().trim().toLowerCase();          
        }
      }
      if (emailTall.trim() !== "" && this.infoPeticion.agente.toString().trim() != "135312") {
        result.push(emailTall);        
      }
      // Obtener email del comercial
      res = await this.agentsService.getEmailComercial(this.data.token, this.infoPeticion.taller);

      if (res.length > 0 && res[0].emailcial.toString().trim() != "") {
        res.forEach(datoscial => {
          let emailcial = datoscial.emailcial.toString().trim().toLowerCase();
          if (emailcial != "" && !result.includes(emailcial)) {
            result.push(emailcial);
          }
        });
      }
      // Obtener email del manager comercial
      res = await this.agentsService.getEmailManager(this.data.token, this.infoPeticion.taller);

      if (res.length > 0 && res[0].emailzona.toString().trim() != "") {
        res.forEach(datoscialzona => {
          let emailzona = datoscialzona.emailzona.toString().trim().toLowerCase();
          if (emailzona != "" && !result.includes(emailzona)) {
            result.push(emailzona);
          }
        });
      }
    } catch (error) {
      console.error('Error fetching emails:', error);
    }

    return result;
  }

}

export interface ComentarioContact
{
  linea:number, created:string,obser:string,usuario:string;
}